<template>
	<div class="candidate" :class="[active ? 'candidate--active' : '', 'candidate--' + type]" @click="select(candidate.id)" :style="{ flexBasis: width + 'px' } ">
		<div class="candidate__image">
			<img :src="!!candidate.s3image ? candidate.s3image.url : require('global/assets/nobody.png')" />
		</div>
		<div class="candidate__text">
			<div class="candidate__name">
				{{type != 'toggle-full' ? candidate.last_name : candidate.full_name_clean}} 
			</div>
			<div class="candidate__infos">
				<div class="candidate__party" :style="{ backgroundColor: candidate.party_color }">
					{{type == 'toggle' ? candidate.party_acronym : candidate.party_name}}
				</div>
				<div v-if="!!candidate.last" class="candidate__score">
					{{candidate.lastTxt}}
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'PresiCandidate',
		props: {
			candidate: {
				type: Object,
				required: true,
			},
			type: {
				type: String,
				default: 'toggle',
			},
			width: {
				type: Number,
				default: 160,
			},
			active: {
				type: Boolean,
				default: true,
			}
		},
		methods: {
			select: function(id) {
				this.$emit('select', id)
			}
		},
	}
</script>
<style lang="scss">
	@import 'global/css/contexte.apps';
	@import 'global/css/contexte.apps.colors'; 
	.candidate {
		min-width: 0;
		margin: 0 7px .9em;
		flex: 1 1 200px;
		cursor: pointer;
		display: flex;
		border-top: 2px solid $light-grey;
		&--header {
			margin-left: 0;
			margin-right: 0;
		}
		&:not(.candidate--active) {
			opacity: .5;
			.candidate__party {
				background-color: $medium-grey !important;
			}
			.candidate__image {
				img {
					@include blackwhite(1.2);
				}
			}
		}
		&--active {
			background-color: $field-fill;
			border-color: $dark-grey;
			.person__name {
				font-weight: 600;
			}
		}
		&__image {
			flex: 0 0 70px;
			img {
				// border-radius: 50%;
				width: 100%;
				height: 70px;
				object-fit: cover;
			}
		}
		&__text {
			padding: .5em .5em .5em .7em;
			flex: 1 1 auto;
		}
		&__name {
			font-size: 1em;
			margin-bottom: .5em;
		}
		&__infos {
			display: flex;
			align-items: center;
		}
		&__party {
			color: white;
			display: block;
			font-weight: 400;
			padding: .2em .5em;
			font-size: 12px;
			flex: 0 0 auto;
			text-align: center;
		}
		&__score {
			flex: 1 1 auto;
			text-align: right;
			font-size: 14px;
		}	
	}
	@media screen and (max-width: 1200px)  {
		.candidate:not(.candidate--header):not(.candidate--toggle-full) {
			margin-bottom: .5em;
			.candidate__name {
				font-size: .9em;
			}
			.candidate__image {
				display: none;
			}
			.candidate__party {
				font-size: 11px;
			}
			.candidate__score {
				font-size: 12px;
			}
		}
	}
	@media screen and (max-width: 900px)  {
		.candidate:not(.candidate--header):not(.candidate--toggle-full) {
			flex-basis: 100px;
			margin: 0 5px 10px;
			.candidate__score {
				display: none;
			}
		}
	}

</style>